module.exports = __webpack_public_path__ + "static/img/08.2c92cb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour4/08.jpg
// module id = h7hf
// module chunks = 0